import { useEffect, useState } from 'react';
import { auth } from './firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { setAnalyticsUserId, clearAnalyticsUserId } from '../lib/analytics/gtag';

export default function useAuthUser() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
      setLoading(false);
      if (firebaseUser?.uid) {
        setAnalyticsUserId(firebaseUser.uid);
      } else {
        clearAnalyticsUserId();
      }
    });
    return () => unsubscribe();
  }, []);

  return { user, loading };
}
